import React from 'react'

function ExperienceDetails({course,universty,duration}) {
  return (
    <div className='space-y-2'>
        <h2 className="font-bold text-[1.6rem]">
        {course}
      </h2>
      <h3 className='font-semibold'>{universty}/{duration}</h3>
      <p style={{color:'rgb(108, 117, 125)'}}>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
        necessitatibus officia consequuntur nihil, soluta nesciunt incidunt
        assumenda nisi deleniti dolor dolorem velit iure. Vero consequatur
        molestias culpa, odit architecto recusandae.
      </p>
    </div>
  )
}

export default ExperienceDetails